// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"styles__fallbackContainer___WP54o","darkBackground":"styles__darkBackground___YBXJy"};